import { isNull, isObject } from 'lodash'

import {
  ONBOARDING_DATA_STATUS,
  ONBOARDING_LOADING_DATA_TYPE_MAPPER,
  ONBOARDING_LOADING_STEP_MAPPER,
  ONBOARDING_STATE
} from '@/composables/onboarding-ai-step'
import { isStringEmpty } from '@/utils/general'

export {
  ONBOARDING_LOADING_DATA_TYPE_MAPPER,
  ONBOARDING_LOADING_STEP_MAPPER,
  ONBOARDING_LOADING_VARIANT
} from '@/composables/onboarding-ai-step'

export const isRequestPending = statusId => statusId === ONBOARDING_DATA_STATUS.PENDING

export const isRequestFailed = statusId => statusId === ONBOARDING_DATA_STATUS.FAILED

export const isOnboardingStateFailed = stateId =>
  stateId === ONBOARDING_STATE.FAILED || stateId === ONBOARDING_STATE.COMPLETE_ON_FALLBACK

const isLoadingDataType = dataTypeId => {
  return Object.values(ONBOARDING_LOADING_STEP_MAPPER).some(e => e.dataTypeId === dataTypeId)
}

const statusIdPriority = [
  ONBOARDING_DATA_STATUS.COMPLETED,
  ONBOARDING_DATA_STATUS.FAILED,
  ONBOARDING_DATA_STATUS.PENDING
]

export const findOnboardingDataByType = (data, dataTypeId) => {
  if (isLoadingDataType(dataTypeId)) {
    const targetDataTypeItems = data
      .filter(item => item.dataTypeId === dataTypeId)
      .toSorted(
        (a, b) => statusIdPriority.indexOf(a.statusId) - statusIdPriority.indexOf(b.statusId)
      )
    return targetDataTypeItems[0] ?? null
  }
  return data.findLast(item => item.dataTypeId === dataTypeId)
}

export const tryParseJsonValue = value => {
  if (isObject(value) && !isNull(value)) {
    return value
  }

  if (isNull(value) || isStringEmpty(value)) {
    return undefined
  }

  try {
    return JSON.parse(value)
  } catch {
    return undefined
  }
}

export const getOnboardingDataValue = (
  data,
  dataTypeId,
  { defaultValue, parseJson = false } = {}
) => {
  const value = findOnboardingDataByType(data, dataTypeId)?.value

  if (parseJson) {
    return tryParseJsonValue(value) ?? defaultValue
  }

  return value ?? defaultValue
}

export const getLoadingConfigForStep = stepId => ONBOARDING_LOADING_STEP_MAPPER[stepId] ?? null

export const getLoadingConfigForDataType = dataTypeId =>
  ONBOARDING_LOADING_DATA_TYPE_MAPPER[dataTypeId] ?? null
